const WithImageWraper = ({ children }) => {
  return (
    <div className="image-wraper-container overflow-hidden">
      <div className="background-image" />
      {children}
    </div>
  );
};

export default WithImageWraper;
